import {
	TbMessage2,
	TbClipboardList,
	TbSearch,
	TbScale,
	TbShoppingCartCheck,
	TbTrendingUp,
} from 'react-icons/tb';

/**
 * @desc Stage icons keyed to journeyData stage ids — shared between the
 * homepage journey rail and the sidebar's grouped navigation headers
 */
export const stageIcons = {
	outreach: TbMessage2,
	capture: TbClipboardList,
	match: TbSearch,
	source: TbScale,
	fulfil: TbShoppingCartCheck,
	learn: TbTrendingUp,
};
